export default "__VITE_ASSET__d9bdbdc9__"